import { Injectable } from '@angular/core';

import { BeamType } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class BeamTypeService extends TmsWebBaseEditService<BeamType, BeamType> {
  constructor() {
    super('BeamType', $localize`Beam Type`);
  }
}
